import defaultBgRule from '../default';

const dark = (params) => defaultBgRule.dark(params);

export default dark;
